module.exports = __webpack_public_path__ + "static/img/map3.1d03e65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/map3.png
// module id = 92
// module chunks = 1 4